export function getFormattedDate(date: Date | null, locale: string): string {
  let result = "";

  if (date) {
    const stringValue = date ? date.toLocaleDateString(locale) : "";
    const parts = stringValue.split("/");

    // TODO: Refactor this to use a regex pattern base on locale prop
    result = `${parts[0].padStart(2, "0")}/${parts[1].padStart(2, "0")}/${
      parts[2]
    }`;
  }

  return result;
}

export function isDateDisabled(
  date: Date,
  minDate: string,
  maxDate: string
  // minDate?: Date | null,
  // maxDate?: Date | null
): boolean {
  const isDateMinorThatMinDate = minDate && date < new Date(minDate);
  const isDateMajorThatMaxDate = maxDate && date > new Date(maxDate);

  if (isDateMinorThatMinDate || isDateMajorThatMaxDate) {
    return true;
  }

  return false;
}

export function daysInMonth(month: number, year: number): number {
  return new Date(year, month + 1, 0).getDate();
}

export function getDaysInNextMonth(month: number, year: number): number {
  const nextMonth = (month + 1) % 12;
  const nextYear = month === 11 ? year + 1 : year;

  return daysInMonth(nextMonth, nextYear);
}

export function getFirstDayOfMonth(month: number, year: number) {
  return new Date(year, month, 1).getDay();
}

export function getLastDayOfMonth(month: number, year: number) {
  const daysInCurrentMonth = daysInMonth(month, year);

  return new Date(year, month, daysInCurrentMonth).getDay();
}

export function isCurrentMonth(day: number, month: number, year: number) {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  return day === currentDay && month === currentMonth && year === currentYear;
}

export const monthNames: string[] = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const weekDays: string[] = ["S", "M", "T", "W", "T", "F", "S"];

export const abbreviatedMonthNames = monthNames.map((month) =>
  month.slice(0, 3)
);

export function moveContainerPosition(
  referenceElement: HTMLInputElement,
  containerElement: HTMLElement
) {
  const inputRect = referenceElement.getBoundingClientRect();
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
  const windowHeight = window.innerHeight;
  const calendarHeight = containerElement.scrollHeight;

  const top = inputRect.top + inputRect.height + scrollTop;
  const left = inputRect.left + scrollLeft;
  const calendarTop =
    top + calendarHeight > scrollTop + windowHeight
      ? top - calendarHeight - inputRect.height
      : top;

  containerElement.style.position = "absolute";
  containerElement.style.top = `${calendarTop}px`;
  containerElement.style.left = `${left}px`;
}

function removeNonNumericCharacters(value: string): string {
  return value.replace(/[^0-9/]/g, "");
}

// export function getFormattedDateWithSlashes(date: string): string {
//   let value = date.trim();

//   value = removeNonNumericCharacters(value);

//   value = value.slice(0, 8);

//   if (value.length >= 2 && value[2] !== "/") {
//     value = `${value.slice(0, 2)}/${value.slice(2)}`;
//   }

//   if (value.length >= 5 && value[5] !== "/") {
//     value = `${value.slice(0, 5)}/${value.slice(5)}`;
//   }

//   return value;
// }

export function getFormattedDateWithSlashes(date: string): string {
  let value = removeNonNumericCharacters(date.trim());

  // Limit to MMDDYYYY or DDMMYYYY (8 characters)
  value = value.slice(0, 8);

  if (value.length >= 4) {
    // Insert two slashes when 4+ digits are typed
    value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
  } else if (value.length >= 2) {
    // Insert one slash when 2+ digits are typed
    value = `${value.slice(0, 2)}/${value.slice(2)}`;
  }

  return value;
}


export function isStringDateValid(value: string, locale: string): boolean {
  if (!value.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
    return false;
  }

  const { day, month, year } = getDateParts(value, locale);

  if (!day || !month || !year) {
    return false;
  }

  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  if (monthNum < 1 || monthNum > 12) {
    return false;
  }

  const daysInMonth = new Date(yearNum, monthNum, 0).getDate();
  if (dayNum < 1 || dayNum > daysInMonth) {
    return false;
  }

  return true;
}

export function getDateParts(
  value: string,
  locale: string
): { day: string; month: string; year: string } {
  const parts = value.trim().split("/");

  let day = "";
  let month = "";
  let year = "";

  if (parts.length === 3) {
    if (locale === "en-GB") {
      [day, month, year] = parts;
    } else {
      [month, day, year] = parts;
    }
  }

  return { day, month, year };
}
